module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_3016.e5ebe3e3.png";